import type { TranslationFn } from "@/utils/countries";

/**
 * Translated technology name, e.g. "wind" or "Wind" → "Wind". A technology without a translation
 * is returned as given.
 */
export const translateTechnology = (
  technology: string,
  t: TranslationFn
): string => t(`common.technology.${technology.toLowerCase()}`, technology);
